import React from 'react'
import Img from 'gatsby-image'

//components
import Layout from '../../components/Layout/'
import SEO from '../../components/Seo/'
import Header from '../../components/Header'

// styles
import { BackgroundStrip, TextContent } from "./style"

// Query Images
import usePageQuery from './pageQuery'

const AboutOurAds = () => {
  const data = usePageQuery()
  return (
    <Layout>
      <SEO
        title='About Our Ads'
        description='About Our Ads'
      />
      <Header />
      <BackgroundStrip className='d-none d-lg-block bg-gray-400' />
      <div className='container mt-5'>
        <div className='row'>
          <TextContent className='col-12 col-lg-7'>
            <h2 className='fs-24 fs-md-40 mb-4 mt-4 mt-lg-5 text-blue-900 fw-600'>About our ads</h2>
            <p className='fs-14 lh-19'>
              We use third-party companies to serve advertisements regarding
              goods and services that may be of interest to you when you access
              and use the Services and other online services. Such
              advertisements may be based on information relating to your access
              to and use of the Services and other online services on any of
              your devices.
            </p>

            <p className='fs-14 lh-19'>
              In order to collect such information, these companies place or
              recognize a unique cookie on your browser (including through the
              use of a pixel tag). They also use these technologies, along with
              information they collect about your online use, to recognize you
              across the devices you use, such as a mobile phone and a laptop.
            </p>

            <p className='fs-14 lh-19'>
              If you would like more information about this practice, and to
              learn how to opt out of it in desktop and mobile browsers on the
              particular device on which you are accessing this Privacy Policy,
              please visit:
            </p>

            <p className='fs-14 lh-19'>
              <a
                href='http://optout.aboutads.info/#/'
                target='_blank'
                rel='noreferrer'
                className='fw-600 text-orange-base'
              >
                http://optout.aboutads.info/#/
              </a>
            </p>

            <p className='fs-14 lh-19'>
              <a
                href='http://optout.networkadvertising.org/#/'
                target='_blank'
                rel='noreferrer'
                className='fw-600 text-orange-base'
              >
                http://optout.networkadvertising.org/#/
              </a>
            </p>

            <p className='fs-14 lh-19'>
              You may download the AppChoices app at{' '}
              <a
                href='http://www.aboutads.info/appchoices'
                target='_blank'
                rel='noreferrer'
                className='fw-600 text-orange-base'
              >
                www.aboutads.info/appchoices
              </a>{' '}
              to opt out in mobile apps.
            </p>
          </TextContent>
          <div className='d-none d-lg-block col-lg-5 mt-lg-5'>
            <Img fluid={data.aboutOurAdsImg.fluid} alt='' />
          </div>
        </div>
      </div>
    </Layout>
  )
}
  
  export default AboutOurAds
